export default __webpack_public_path__ + "static/media/ic_user.cd09e492.svg";